import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export class MapsHandler {
    constructor() {
        this.swiper = null;
        this.country = 'france';
        this.mapsContainer = document.querySelector('#maps');
        if (!this.mapsContainer) {
            return;
        }

        this.countriesList = this.mapsContainer.querySelector('.maps__countries');
        this.countriesListItems = this.mapsContainer.querySelectorAll('.maps__countries li');

        this.citiesList = this.mapsContainer.querySelectorAll('.maps__cities');
        this.citiesListItems = this.mapsContainer.querySelectorAll(".maps__cities li");
        this.citiesInfos = this.mapsContainer.querySelectorAll('.maps__infos');
        this.mapsWrapper = this.mapsContainer.querySelector('.maps__maps');
        this.countriesSvgWrapper = this.mapsContainer.querySelectorAll('.maps__maps > div:not(#maps-swiper)');
        this.citiesSvgMarkers = this.mapsContainer.querySelectorAll('.maps__maps > div:not(#maps-swiper) > svg > g');
        this.citiesSvgMarkersMobile = this.mapsContainer.querySelectorAll('.maps__maps > #maps-swiper svg > g');
    }

    setUniqueActive(items, activeItem) {
        items.forEach(item => item.classList.remove('is-active'));
        activeItem.classList?.add('is-active');
    }

    changeCitiesListFromCountry(country) {
        const countryCities = this.mapsContainer.querySelector('.maps__cities--' + country);
        if (countryCities) {
            this.setUniqueActive(this.citiesList, countryCities);
            countryCities.querySelector('li')?.click();
        }
    }

    setMasterClassForOrderedCountries(country) {
        this.mapsWrapper.classList.remove('is-active__france', 'is-active__portugal', 'is-active__canada');
        this.mapsWrapper.classList.add('is-active__' + country);
        this.countriesList.classList.remove('is-active__france', 'is-active__portugal', 'is-active__canada');
        this.countriesList.classList.add('is-active__' + country);
    }

    calculateAndDisplayNumbersOfAgenciesAndCDS(selectedMapSvgWrapper) {
        const selectedCountryCities = selectedMapSvgWrapper.querySelectorAll(':scope > svg > g');
        let nbCDS = 0;
        let nbAgencies = 0;
        selectedCountryCities.forEach((city) => {
            if (city.querySelectorAll(':scope > path').length > 2) {
                nbCDS++;
            }

            nbAgencies++;
        });

        const nbCdsElement = this.mapsContainer.querySelector('#nb-cds');
        const nbAgenciesElement = this.mapsContainer.querySelector('#nb-agencies');
        if (nbCdsElement) {
            nbCdsElement.innerHTML = nbCDS;
            if (nbCDS === 0) {
                nbCdsElement.parentElement.parentElement.style.display = 'none';
            } else {
                nbCdsElement.parentElement.parentElement.style.display = 'flex';
            }

            if (nbCDS === 1) {
                nbCdsElement.nextElementSibling.innerHTML = 'CENTRE DE SERVICE';
            } else {
                nbCdsElement.nextElementSibling.innerHTML = 'CENTRES DE SERVICE';
            }
        }

        if (nbAgenciesElement) {
            nbAgenciesElement.innerHTML = nbAgencies;

            if (nbAgencies === 1) {
                nbAgenciesElement.nextElementSibling.innerHTML = 'AGENCE';
            } else {
                nbAgenciesElement.nextElementSibling.innerHTML = 'AGENCES';
            }
        }
    }

    setCountry(country) {
        this.country = country;

        const countryLi = this.mapsContainer.querySelector('.maps__countries li.' + country);
        if (countryLi) {
            this.setUniqueActive(this.countriesListItems, countryLi);
        }

        this.changeCitiesListFromCountry(country);
        this.setMasterClassForOrderedCountries(country);

        const selectedMapSvgWrapper = this.mapsWrapper.querySelector(':scope > .maps__maps--' + country);
        if (selectedMapSvgWrapper) {
            this.setUniqueActive(this.countriesSvgWrapper, selectedMapSvgWrapper);
            // this.calculateAndDisplayNumbersOfAgenciesAndCDS(selectedMapSvgWrapper);
        }

        if (this.swiper) {
            switch (country) {
                case 'france':
                    this.swiper.slideTo(1);
                    break;
                case 'portugal':
                    this.swiper.slideTo(2);
                    break;
                case 'canada':
                    this.swiper.slideTo(0);
                    break;
            }
        }
    }

    handleCountryClick(event) {
        const country = event.currentTarget.classList[0];
        if (!country) {
            return;
        }

        this.setCountry(country);
    }

    handleCityClick(event) {
        this.setUniqueActive(this.citiesListItems, event.currentTarget);

        const currentCity = event.currentTarget.classList[0];
        if (!currentCity) {
            return;
        }

        const currentCityInfos = this.mapsContainer.querySelector('.maps__infos.' + currentCity);
        if (currentCityInfos) {
            this.setUniqueActive(this.citiesInfos, currentCityInfos);
        } else {
            this.citiesInfos.forEach(cityInfo => cityInfo.classList.remove('is-active'));
        }

        // Carte WEB
        const svgMap = this.mapsWrapper.querySelector(':scope > .maps__maps--' + this.country + ' svg');
        if (!svgMap) {
            return;
        }

        const city = svgMap.querySelector(':scope > g[id="' + currentCity + '"]');
        if (city) {
            this.setUniqueActive(this.citiesSvgMarkers, city);
        }

        // Carte MOBILE
        const svgMapMobile = this.mapsWrapper.querySelector(':scope > #maps-swiper .maps__maps--' + this.country + ' svg');
        if (!svgMapMobile) {
            return;
        }

        const cityMobile = svgMapMobile.querySelector(':scope > g[id="' + currentCity + '"]');
        if (cityMobile) {
            this.setUniqueActive(this.citiesSvgMarkersMobile, cityMobile);
        }
    }

    handleCitySvgMarkerClick(event) {
        const city = event.currentTarget.getAttribute('id');
        this.citiesListItems.forEach((cityItem) => {
            if (cityItem.classList.contains(city)) {
                cityItem.click();
            }
        });
    }

    handleCountryDivClick(event) {
        if (event.currentTarget.classList.contains('is-active')) {
            return;
        }

        const countryName = event.currentTarget.querySelector('svg').getAttribute('id');
        this.countriesListItems.forEach((countryItem) => {
            if (countryItem.classList.contains(countryName)) {
                countryItem.click();
            }
        });
    }

    initSwiper() {
        this.swiper = new Swiper('#maps-swiper', {
            modules: [Navigation, Pagination],
            slidesPerView: 2.5,
            centeredSlides: true,
            initialSlide: 1,
            wrapperClass: 'maps-swiper-wrapper',
            slideClass: 'wp-block-group',
            slideActiveClass: 'is-active',
            on: {
                slideChange: (swiper) => {
                    const country = swiper.slides[swiper.activeIndex]?.querySelector('svg').getAttribute('id');
                    if (country) {
                        this.countriesListItems.forEach((countryItem) => {
                            if (countryItem.classList.contains(country)) {
                                countryItem.click();
                            }
                        });
                    }
                },
            },
            enabled: true,
            navigation: {
                prevEl: '.maps-swiper-navigation-prev',
                nextEl: '.maps-swiper-navigation-next',
            },
        });
    }

    init() {
        if (!this.mapsContainer) {
            return;
        }

        this.countriesListItems?.forEach(country => {
            country.addEventListener('click', this.handleCountryClick.bind(this));
        });

        this.citiesListItems?.forEach(city => {
            city.addEventListener('click', this.handleCityClick.bind(this));
        });

        this.citiesSvgMarkers?.forEach(city => {
            city.addEventListener('click', this.handleCitySvgMarkerClick.bind(this));
        });

        this.countriesSvgWrapper?.forEach(country => {
            country.addEventListener('click', this.handleCountryDivClick.bind(this));
        });

        this.countriesListItems[0]?.click();

        this.initSwiper();
    }
}
